<script>
import { formRenderMixin } from '@/mixins/formRender';

import AppealDate from './actionData/AppealDate';
import Archive from './actionData/Archive';
import BeforeDocumentCreate from './actionData/BeforeDocumentCreate';
import BiK from './actionData/BiK';
import Certificate from './actionData/Certificate';
import Comment from './actionData/Comment';
import Confirm from './actionData/Confirm';
import ConfirmForm from './actionData/ConfirmForm';
import ConfirmMdokSubmit from './actionData/ConfirmMdokSubmit';
import ConfirmRecruitmentClose from './actionData/ConfirmRecruitmentClose';
import DateRangeStart from './actionData/DateRangeStart';
import DecisionEnd from './actionData/DecisionEnd';
import DecisionStart from './actionData/DecisionStart';
import DeliveryDate from './actionData/DeliveryDate';
import DeliveryDateExtended from './actionData/DeliveryDateExtended';
import Diploma from './actionData/Diploma';
import FileTransfer from './actionData/FileTransfer';
import GeneralContent from './actionData/GeneralContent';
import GeneralDeed from './actionData/GeneralDeed';
import Invitation from './actionData/Invitation';
import Judgment from './actionData/Judgment';
import KoReport from './actionData/KoReport';
import ListOfSko from './actionData/ListOfSko';
import Mdok from './actionData/Mdok';
import NoForm from './actionData/NoForm';
import PreventDecision from './actionData/PreventDecision';
import PrezydenckiData from './actionData/PrezydenckiData';
import Reason from './actionData/Reason';
import ReplyFormSelect from './actionData/ReplyFormSelect';
import SchoolSubmitEPUAP from './actionData/SchoolSubmitEPUAP';
import SubmitEPUAP from './actionData/SubmitEPUAP';
import SubmitManually from './actionData/SubmitManually';
import SubmitSigned from './actionData/SubmitSigned';
import Address from './filters/Address';
import CheckboxList from './filters/CheckboxList';
import ExcludeRadio from './filters/ExcludeRadio';
import NumberRange from './filters/NumberRange';
import Radio from './filters/Radio';
import SchoolPicker from './filters/SchoolPicker';
import TextInput from './filters/TextInput';

// @vuese
// Renderer formularza danych akcji
export default {
  components: {
    Address,
    AppealDate,
    Archive,
    BeforeDocumentCreate,
    BeforeDuplicatesDocumentCreate: BeforeDocumentCreate,
    BeforeOw004DocumentCreate: BeforeDocumentCreate,
    BoolRadio: Radio,
    BiK,
    CheckboxList,
    Certificate,
    Comment,
    ConfirmForm,
    ConfirmMdokSubmit,
    ConfirmPack: Confirm,
    ConfirmRecruitmentClose,
    ConfirmRemoveAnnounecment: Confirm,
    ConfirmRemoveDocument: Confirm,
    DecisionStart,
    DecisionHoldEnd: DecisionEnd,
    DecisionHoldOrWithdrawalEnd: DecisionEnd,
    DecisionWithdrawalEnd: DecisionEnd,
    DeliveryDate,
    DeliveryDateExtended,
    Diploma,
    ExcludeBooleanRadio: ExcludeRadio,
    ExcludeRadio,
    ExistRadio: Radio,
    FileTransfer,
    GeneralContent,
    GeneralDeed,
    Invitation,
    Judgment,
    KoReport,
    Mdok,
    NoForm,
    NumberRange,
    OW004ListOfSko: ListOfSko,
    PreventDecision,
    PrezydenckiData,
    Radio,
    Reason,
    ReplyFormSelect,
    SchoolPicker,
    SchoolSubmitEPUAP,
    SendToFix: Comment,
    SubmitEPUAP,
    SubmitSigned,
    SubmitSignedPrezydencki: SubmitSigned,
    SubmitManually,
    SubmitManuallyAnnouncement: SubmitManually,
    SubmitManuallyConfirm: SubmitManually,
    SubmitManuallyDuplicates: SubmitManually,
    SuspensionDateSubmit: DateRangeStart,
    TextInput,
    WithdrawalDateSubmit: DateRangeStart
  },
  mixins: [formRenderMixin]
};
</script>
